import { usePageActivated } from 'app-layered-layout/usePageActivated'
import { useParamsOfPage } from 'hooks/useNavigateTo'
import SharePanel from './component/SharePanel'

export default function SharePage() {
  const pageActivated = usePageActivated()
  const params = useParamsOfPage('share')

  return (
    <SharePanel
      active={pageActivated}
      videoShareUrl={params?.videoShareUrl}
      onClose={({ close }) => {
        close()
      }}
    />
  )
}
